var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c('ProjectsList',{attrs:{"projects":_vm.projects}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"photo",staticStyle:{"margin-bottom":"10px","margin-left":"10px"}},[_c('img',{staticClass:"responsive-logo",attrs:{"src":"img/TM_Logo_sideways_transparent.png","alt":"Tarek Mongy"}})])
}]

export { render, staticRenderFns }